"use client";

import {
  Accordion,
  AccordionItem,
  AccordionPanel,
  AccordionTrigger,
} from "@tillix/ui-atoms/atoms/accordion";
import { Badge } from "@tillix/ui-atoms/atoms/badge";
import { useT } from "@/features/i18n/hooks/use-t";
import type { FAQItem } from "./faqData";

interface FAQItemsAccordianProps {
  filteredItems: FAQItem[];
}
export default function FAQItemsAccordian({
  filteredItems,
}: FAQItemsAccordianProps) {
  const { t } = useT();

  return (
    <div className="flex-1">
      {filteredItems.length > 0 ? (
        <Accordion>
          {filteredItems.map((item) => (
            <AccordionItem key={item.id} value={item.id}>
              <AccordionTrigger
                className="group text-left hover:no-underline"

                // icon={<HowardAnimatedPlusMinusToggleIcon className="ml-6" />}
              >
                {t(item.questionKey)}
              </AccordionTrigger>
              <AccordionPanel>
                <div>{t(item.answerKey)}</div>

                {/* Tags */}
                {item.tags.length > 0 && (
                  <div className="mt-4 flex flex-wrap gap-2 text-muted-foreground text-xs">
                    {item.tags.map((tag) => (
                      <Badge
                        className="bg-tenant-howard-county-primary-light-gray text-tenant-howard-county-primary-primary-blue hover:bg-tenant-howard-county-primary-light-gray"
                        key={tag}
                      >
                        #{tag}
                      </Badge>
                    ))}
                  </div>
                )}
              </AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      ) : (
        <div className="py-8 text-center text-muted-foreground">
          <p>{t("faq.noFaqsFound")}</p>
        </div>
      )}
    </div>
  );
}
